import nextEntityWithNumberNameGenerator from './nextEntityWithNumberNameGenerator';

export function nextCohortNameGenerator(items) {
    return nextEntityWithNumberNameGenerator(items, 'My cohort');
}

export default nextCohortNameGenerator;
